export const editProfile = {
  pageTitle: "プロフィール編集",
  sections: {
    account: "アカウント",
    introduction: "自己紹介",
    profile: "プロフィール",
  },
  changeImage: "写真を変更",
  changeName: "名前を変更",
  age: "年齢",
  region: "地域",
  talkTheme: "通話内容の希望",
  hobby: "趣味",
  personality: "性格",
  bodyType: "体型",
  activeTime: "よくいる時間帯",
  occupation: "職業",
  preferredLooks: "好みのルックス",
  holiday: "休日",
  housemate: "同居人",
  bloodType: "血液型",
  alcohol: "お酒",
  smoking: "タバコ",
  save: "保存",
  cancel: "キャンセル",
  nameLabel: "ニックネーム",
  bioLabel: "自己紹介",
  noticeText: "全て登録して注目度UPしよう！",
  pointTarget: "ポイント対象",
} as const;
